export function parsePermissionId(permissionId) {
  const [scope, resource, action] = permissionId.split(':')

  return {
    scope,
    resource,
    action,
  }
}
